import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from './tracker';

export const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackEvent('PAGE_VIEW', { path: location.pathname });
  }, [location.pathname]);

  return null;
};
